import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Divider,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { Flex } from "@chakra-ui/react";
import { DateTime } from "luxon";
import {
  PAYOUT_AUDIENCES,
  PAYOUT_MODES,
  PAYOUT_SESSION_KEYS,
  normalizePayoutSheet,
} from "../../Config/ExpertPayoutPrices";

export const ExpertPriceCard = ({
  props,
  editFunction,
  deleteFunction,
}: any) => {
  const { data, id, date_time } = props;
  const sheet = normalizePayoutSheet(data);

  function formatDateTime(dateTimeString: any) {
    if (typeof dateTimeString === "string") {
      const dateTime = DateTime.fromISO(dateTimeString, {
        zone: "Asia/Kolkata",
      });
      return dateTime.toFormat("dd/MM/yyyy-HH:mm:ss");
    } else if (typeof dateTimeString === "number") {
      const dateTime = DateTime.fromMillis(dateTimeString, {
        zone: "Asia/Kolkata",
      });
      return dateTime.toFormat("dd/MM/yyyy-HH:mm:ss");
    } else {
      return dateTimeString;
    }
  }
  function convertDateFormat(dateString: any) {
    if (!dateString) {
      return "";
    }

    const [year, month, day] = dateString.split("-");

    if (!year || !month || !day) {
      return "";
    }

    return `${day}/${month}/${year}`;
  }
  return (
    <Card borderWidth="1px" borderRadius="lg" boxShadow="md" mb={1}>
      <CardBody>
        <Stack>
          <Flex justifyContent="space-between">
            <Box>
              <Text fontSize="sm">From: {convertDateFormat(sheet.fromDate)}</Text>
            </Box>
            <Box>
              <Text fontSize="sm">To: {convertDateFormat(sheet.toDate)}</Text>
            </Box>
          </Flex>
          {PAYOUT_MODES.map((mode) => (
            <Box key={mode.value}>
              <Divider />
              <Text fontSize="sm" fontWeight="bold" mt={2} mb={1}>
                {mode.label}
              </Text>
              <Flex justifyContent="space-between" alignItems="center">
                <Box>
                  <Text fontSize="sm">Audience</Text>
                </Box>
                <Box>
                  <Text fontSize="sm">1 Session</Text>
                </Box>
                <Box>
                  <Text fontSize="sm">3 Session</Text>
                </Box>
                <Box>
                  <Text fontSize="sm">5 Session</Text>
                </Box>
                <Box>
                  <Text fontSize="sm">10 Session</Text>
                </Box>
              </Flex>
              {PAYOUT_AUDIENCES.map((audience) => (
                <Flex
                  key={`${audience.value}-${mode.value}`}
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Text fontSize="sm">{audience.label}</Text>
                  </Box>
                  {PAYOUT_SESSION_KEYS.map((key) => (
                    <Box key={key}>
                      <Text fontSize="md" fontWeight="bold">
                        {sheet?.[audience.value]?.[mode.value]?.[key] || "-"}
                      </Text>
                    </Box>
                  ))}
                </Flex>
              ))}
            </Box>
          ))}
        </Stack>
        <Divider />
        <Flex justifyContent="space-between">
          <ButtonGroup>
            <Button
              variant="ghost"
              color="#327171"
              size="sm"
              onClick={() => editFunction(id, props.data)}
            >
              Edit
            </Button>
            <Button
              variant="ghost"
              color="red"
              size="sm"
              onClick={() => deleteFunction(id)}
            >
              Delete
            </Button>
          </ButtonGroup>
          <Text>Added at : {formatDateTime(date_time)}</Text>
        </Flex>
      </CardBody>
    </Card>
  );
};
